export default __webpack_public_path__ + "static/media/main_logo1.5ec96bb4.svg";